import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import $ from 'jquery';

class CreateCompany extends Component {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
  }

  submit(evt) {
    evt.preventDefault();

    const $form = $(evt.target);
    const data = new FormData($form[0]);
    this.props.onSubmit(data);
  }

  render() {
    const { onClose } = this.props;

    return (
      <Modal isOpened closable onClose={onClose}>
        <div className="header">Créer une société</div>
        <div className="content">
          <form
            id="companyForm"
            ref="form"
            className="ui form"
            onSubmit={this.submit}
          >
            <div className="ui field">
              <label>Nom (*)</label>
              <input type="text" name="name" required="required" />
            </div>
          </form>
        </div>
        <div className="actions">
          <button
            type="submit"
            form="companyForm"
            className="ui primary button"
          >
            Enregister
          </button>
        </div>
      </Modal>
    );
  }
}

CreateCompany.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CreateCompany;



// WEBPACK FOOTER //
// ./src/modules/admin/components/CreateCompany.js